import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';

export function MfaResetRequest() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api('/api/auth/mfa-reset/request', { method: 'POST', body: { email } });
    } finally {
      setSent(true);
      setBusy(false);
    }
  }

  return (
    <div className="card narrow">
      <h1>Lost your authenticator and passkeys?</h1>
      <p className="lede">An owner of your workspace has to confirm it is really you, usually on a quick video call. Until they do, your access to customer orgs is paused.</p>
      {sent ? (
        <div className="ok">
          If that email has an account, its owners have been told. Once one of them approves, you will get an email with a link that works for 15 minutes.
        </div>
      ) : (
        <form onSubmit={submit}>
          <label>
            Your work email
            <input id="reset-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <button type="submit" className="block" disabled={busy}>{busy ? 'Sending…' : 'Ask for a reset'}</button>
        </form>
      )}
      <p className="small muted" style={{ marginTop: 20, marginBottom: 0 }}><Link to="/login">Back to sign in</Link></p>
    </div>
  );
}
